export enum Tenor {
  EMPTY,
  TDY,
  TOM,
  SPOT,
  SN,
  W1,
  W2,
  W3,
  M1,
  M2,
  M3,
  M4,
  M5,
  M6,
  M7,
  M8,
  M9,
  M10,
  M11,
  Y1,
  M13,
  M14,
  M15,
  M16,
  M17,
  M18,
  M19,
  M20,
  M21,
  M22,
  M23,
  Y2,
  Y3,
  Y4,
  Y5,
  Y6,
  Y7,
  Y8,
  Y9,
  Y10,
  ALL,
}

export namespace Tenor {
  let elements = [
    Tenor.EMPTY,
    Tenor.TDY,
    Tenor.TOM,
    Tenor.SPOT,
    Tenor.SN,
    Tenor.W1,
    Tenor.W2,
    Tenor.W3,
    Tenor.M1,
    Tenor.M2,
    Tenor.M3,
    Tenor.M4,
    Tenor.M5,
    Tenor.M6,
    Tenor.M7,
    Tenor.M8,
    Tenor.M9,
    Tenor.M10,
    Tenor.M11,
    Tenor.Y1,
    Tenor.M13,
    Tenor.M14,
    Tenor.M15,
    Tenor.M16,
    Tenor.M17,
    Tenor.M18,
    Tenor.M19,
    Tenor.M20,
    Tenor.M21,
    Tenor.M22,
    Tenor.M23,
    Tenor.Y2,
    Tenor.Y3,
    Tenor.Y4,
    Tenor.Y5,
    Tenor.Y6,
    Tenor.Y7,
    Tenor.Y8,
    Tenor.Y9,
    Tenor.Y10,
    Tenor.ALL,
  ];
  let alias = "com.bcdfx.model.Tenor";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
